/**
 * Helpers shared by the Uniswap-flavoured adapter panels.
 *
 * Small enough to inline at each call site, but extracted here so the
 * v3 / v4 panels share the *exact* same coin-extraction rule — if we
 * later switch from "first segment of the pair" to "explicit coin
 * symbol on the adapter shape", a single edit lands the change on
 * every panel.
 */

/**
 * Extract the lead coin symbol from a `"TAKEOVER / WETH"` style pair
 * label. The first non-empty segment is treated as the "coin" the
 * pool is for — matching how the lobby's pair labels are constructed
 * (`<non-base> / <base>`, e.g. `pickNonBaseSymbol` in
 * `data-sources/envio-client.ts` puts WETH/USDC last when one of
 * each is present).
 *
 * Falls back to the raw pair string when the format is unfamiliar
 * (no `/` separator, all-empty segments) so the column never blanks
 * out — the user still gets *some* descriptor under the Coin label.
 */
export function pairToCoinSymbol(pair: string): string {
  const parts = pair
    .split('/')
    .map((p) => p.trim())
    .filter(Boolean);
  return parts[0] ?? pair;
}
